import React from 'react';
import './ledger-screen.scss';
import {
  FallBackScreen,
  LedgerHeader,
} from '@zonofi/zono-money-whatsapp-stack';
import { useLedgerScreen } from './hooks/use-ledger-screen';
import { LoadingSpinner, PNGS, SVGS } from '@zonofi/zono-money-design-system';
import { LedgerView } from '@zonofi/mobile-web-common';
import { FilterModal } from '@zonofi/seller-hub/components/filter/filter-modal';
import { FilterRoute } from '@zonofi/zono-money-store';
export const LedgerScreen: React.FC = () => {
  const {
    pageNo,
    isEmpty,
    error,
    isLedgerLoading,
    ledgerList,
    onScroll,
    lastItemRef,
    isEndOfList,
    ledgerListAPIResponse,
    getLedgerSummaryAPIResponse,
    filterPage,
    openFiltersDrawer,
    setFilterPage,
  } = useLedgerScreen();

  return (
    <div className="ledger-screen">
      <div className="ledger-screen-header-category-container">
        <LedgerHeader openFiltersDrawer={openFiltersDrawer} />
      </div>
      {error?.show && (
        <div className="ledger-screen-error-section font-primary">
          <h2 className=" font-primary">{error?.code}</h2>
          <span className="font-primary-semibold">{error?.message}</span>
        </div>
      )}
      {isLedgerLoading ? (
        <div className="ledger-screen-loading">
          <LoadingSpinner />
        </div>
      ) : isEmpty ? (
        <FallBackScreen
          image={PNGS.EmptyLedger}
          message="No Ledger Found."
          description=""
          contentStyle={{
            justifyContent: 'center',
          }}
        />
      ) : ledgerList?.length > 0 ? (
        <>
          <LedgerView
            ledgerListData={ledgerList}
            onScroll={onScroll}
            lastItemRef={lastItemRef}
            isLedgerListLoading={isLedgerLoading}
            creditLimit={ledgerListAPIResponse?.data?.creditLimit}
            trialBalanceSummary={getLedgerSummaryAPIResponse?.data}
            isEndOfList={isEndOfList}
            isTrialBalanceSummaryLoading={
              getLedgerSummaryAPIResponse?.isLoading ||
              getLedgerSummaryAPIResponse?.isFetching
            }
          />
        </>
      ) : (
        !error?.show && (
          <div className="ledger-screen-loading">
            <LoadingSpinner />
          </div>
        )
      )}
      <FilterModal
        open={!!filterPage}
        onClose={() => {
          setFilterPage('');
        }}
        route={FilterRoute.Ledger}
        filterPage={filterPage}
        dateSelectionMode="dateRange"
      />
    </div>
  );
};
